import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class AddToCart extends kr.Component {
    init() {
        this.currentProductId = null;
        this.modal = null;
        this.loading = false;
        this.ajax_url = window.ajax_url;
        this.$ = window.jQuery;

        this.app.addEvent('buymodal--init');
        this.app.addEvent('buymodal--reload');
        this._initModal();
        this.bind();
    }

    bind()
    {
        this.on('click', '.js-productAddToCart', async (target, event) => {
            event.preventDefault();
            if (this.loading) {
                alert('Process in progress... Wait');
                return false;
            }
            const productId = target.parentNode.parentNode.getAttribute('data-productid');

            this.currentProductId = productId;
            const text = target.innerHTML;
            target.innerHTML = window.translate.processing;
            target.setAttribute('disabled', 'disabled');
            await this._loadContent();
            this.dom.$window.dispatchEvent(this.app.getEvent('buymodal--reload'));
            target.removeAttribute('disabled');
            target.innerHTML = text;
        });
    }

    async _loadContent()
    {
        this.loading = true;
        const data = {
            action: 'wooShowBuyModal',
            product_id: this.currentProductId
        }
        const result = await this.$.post(this.ajax_url, data).then();
        this.loading = false;
        this._addContent(result);
        HTMLClass.addClass(this.app.dom.$body, 'buymodal--opened');
    }

    _addContent(content)
    {
        this.modal.innerHTML = content;
        const dels = this.modal.querySelectorAll(`del`);
        for (let i in dels) {
            if (!dels.hasOwnProperty(i)) {
                continue;
            }

            dels[i].parentNode.removeChild(dels[i]);
        }
    }

    _initModal()
    {
        this.modal = document.querySelector('div.buymodal');
        if (this.modal === null) {
            this.modal = document.createElement('div');
            HTMLClass.addClass(this.modal, 'buymodal');
            this.app.dom.$body.querySelector('.web__root').append(this.modal);
            setTimeout(() => {
                this.dom.$window.dispatchEvent(this.app.getEvent('buymodal--init'));
            }, 500);
        }

    }
}

kr.registerComponent('.js-products', {
    component: AddToCart
});
